import copy from "../../Assets/icons/copy.svg";
import x from "../../Assets/icons/X.svg";

export default function SocialHandles({ handleCopyArticle, isArticle }) {
  return (
    <div className="flex flex-wrap gap-3 mb-4 lg:mb-0">
      <img
        src="/facebook.svg"
        alt="Facebook"
        onClick={() =>
          window.open("https://www.facebook.com/mushtaqanenoor", "_blank")
        }
        className="cursor-pointer"
      />
      <img
        src={x}
        alt="Twitter"
        onClick={() =>
          window.open("https://twitter.com/mushtaqanenoor", "_blank")
        }
        className="cursor-pointer size-10 bg-white rounded-lg p-2"
      />
      <img
        src="/instagram.svg"
        alt="Instagram"
        onClick={() =>
          window.open("https://www.instagram.com/mushtaqanenoor/", "_blank")
        }
        className="cursor-pointer"
      />
      <img
        src="/youtube.svg"
        alt="Youtube"
        onClick={() =>
          window.open(
            "https://www.youtube.com/channel/UCtIZIBZBsQIatNLDyXJC6CQ",
            "_blank",
          )
        }
        className="cursor-pointer"
      />
      <img
        src="/threads.svg"
        alt="Threads"
        onClick={() =>
          window.open("https://www.threads.net/@mushtaqanenoor?hl=en", "_blank")
        }
        className="cursor-pointer"
      />
      {isArticle && (
        <img
          src={copy}
          alt="Copy Article"
          onClick={handleCopyArticle}
          className="cursor-pointer w-10 h-10 bg-primaryBG rounded-lg" // Adjust size to match other icons
          title="مضمون کاپی کریں" // Tooltip for accessibility
        />
      )}
    </div>
  );
}
